<template>
  <div class="top-bar">
    <div class="row">
      <div
        class="col"
        width="50%">
        <main-search/>
      </div>
      <div
        class="col text-right"
        width="50%" >
        <el-dropdown
          trigger="click"
          style="margin-top:5px"
          @command="clickOnDropDownItem">
          <el-button
            type="link"
            class="el-dropdown-link">
            <i class="icon-more_vert"/>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="onLogout">
              <span><i class="icon-save"/> Cerrar sesión</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>

import AuthService from '@/services/auth.service'
import MainSearch from './main-search'

export default {
  name: 'TopBar',
  components: {
    MainSearch
  },
  methods: {
    clickOnDropDownItem (command) {
      if (command === 'onLogout') {
        this.onLogout()
      }
    },
    onLogout () {
      AuthService.logout()
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.top-bar {
  background-color: #fff;
  height: 50px;
  border-bottom: 1px solid #dddddd;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/main-layout/main-top-bar.vue